import { MeasuringStrategy } from '@dnd-kit/core';
import { restrictToFirstScrollableAncestor, restrictToHorizontalAxis, restrictToParentElement, restrictToVerticalAxis, restrictToWindowEdges } from '@dnd-kit/modifiers';
import { arraySwap, horizontalListSortingStrategy, rectSortingStrategy, rectSwappingStrategy, verticalListSortingStrategy, defaultAnimateLayoutChanges } from '@dnd-kit/sortable';
import { GridContainer, ListContainer, DragItemContainer } from './containers.js';
import { DragHandle, RemoveButton } from './controls.js';
import { DragContainer } from './DragContainer.js';
import { GenericDragContext } from './GenericDragContainer.js';

const Drag = Object.assign(DragContainer, {
  Grid: GridContainer,
  List: ListContainer,
  Item: DragItemContainer,
  Handle: DragHandle,
  Remove: RemoveButton
});
const drag = Object.assign({}, {
  arraySwap,
  horizontalListSortingStrategy,
  rectSortingStrategy,
  rectSwappingStrategy,
  verticalListSortingStrategy,
  restrictToFirstScrollableAncestor,
  restrictToHorizontalAxis,
  restrictToParentElement,
  restrictToVerticalAxis,
  restrictToWindowEdges,
  defaultAnimateLayoutChanges,
  MeasuringStrategy,
  GenericDragContext
});

export { Drag, drag };
